import { render } from "./InscriptionModal.vue?vue&type=template&id=5c33c7b2&scoped=true"
import script from "./InscriptionModal.vue?vue&type=script&lang=js"
export * from "./InscriptionModal.vue?vue&type=script&lang=js"

import "./InscriptionModal.vue?vue&type=style&index=0&id=5c33c7b2&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c33c7b2"]])

export default __exports__